import React from 'react';
import fetchWrapper from '../../helpers/fetchWrapper';
import { Cascader } from 'antd';
import { Fragment, useEffect, useState } from 'react';

export const FormCascader = ({
	value = '',
	onChange,
	getEvent,
	name,
	slug,
	disabled,
	dropdownOptions,
	extra,
	...rest
}) => {
	const { menu_id } = rest;
	const [options, setOptions] = useState();
	const [selectedValue, setSelectedValue] = useState(value);

	function handleChange(value) {
		// set selected item
		setSelectedValue(value);

		// set form value
		if (onChange) {
			onChange(value);
		}

		// return event values
		if (getEvent) {
			const target = {
				name,
				value,
			};
			getEvent({ target });
		}
	}

	// fetch data
	const fetchData = async () => {
		const response = await fetchWrapper.post('tree/treedata', {
			tree_slug: slug,
			external_data: extra,
			menu_id,
		});

		if (!response.error && response.data) {
			setOptions(response.data);
		}
	};

	const filter = (inputValue, path) =>
		path.some((option) => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);

	useEffect(() => {
		if (slug && slug != '') {
			fetchData();
		} else if (dropdownOptions.constructor === Array && Object.keys(dropdownOptions).length > 0) {
			setOptions(dropdownOptions);
		}

		return () => {
			setSelectedValue([]);
		};
	}, [slug, extra, menu_id]);

	useEffect(() => {
		setSelectedValue(value);
	}, [value]);

	return (
		<Fragment>
			<Cascader
				getPopupContainer={(triggerNode) => triggerNode.parentNode}
				name={name || 'option_name'}
				value={selectedValue}
				options={options}
				onChange={handleChange}
				maxtagcount="responsive"
				placeholder={rest.placeholder ?? 'Please select'}
				changeOnSelect
				disabled={disabled}
				showSearch={{
					filter,
				}}
			/>
		</Fragment>
	);
};
export default FormCascader;
